import ProductsComponent from '../components/products/products'

const Products = () => <ProductsComponent />

export default Products;